import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp } from "@fortawesome/free-solid-svg-icons";
import { THEME_COLORS } from "../../../core/Constant";
import { getDropzoneAccept } from "../../../core/fileUtils";

const ThumbnailUploadComponent = ({
  value,
  onChange,
  accept = [".png", ".jpg", ".jpeg", ".webp"],
  label = "Click to upload or drag and drop",
  description = "SVG, PNG, JPG or GIF (max, 800x400px)",
}) => {
  const dropzoneAccept = React.useMemo(() => getDropzoneAccept(accept), [accept]);

  const { getRootProps, getInputProps, isDragActive, fileRejections, open } =
    useDropzone({
      noClick: true,
      multiple: false,
      accept: dropzoneAccept,
      onDropAccepted: (acceptedFiles) => {
        onChange?.(acceptedFiles[0] ?? null);
      },
      onDropRejected: () => {
        onChange?.(null);
      },
    });

  return (
    <>
      <Box
        {...getRootProps()}
        onClick={open}
        sx={{
          border: "2px dashed",
          borderColor: isDragActive ? THEME_COLORS.primary : "#D9DDF0",
          borderRadius: 3,
          p: 4,
          textAlign: "center",
          cursor: "pointer",
          transition: ".25s",

          "&:hover": {
            borderColor: THEME_COLORS.primary,
          },
        }}
      >
        <input {...getInputProps()} />

        <Box
          sx={{
            width: isDragActive ? 80 : 70,
            height: isDragActive ? 80 : 70,
            bgcolor: THEME_COLORS.primaryLight,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <FontAwesomeIcon
            icon={faCloudArrowUp}
            color={THEME_COLORS.primary}
            size={isDragActive ? "3x" : "2x"}
          />
        </Box>

        <Stack>
          <Typography component={"span"} fontWeight={600} fontSize={14}>
            {label}
          </Typography>

          <Typography
            component={"span"}
            variant="body2"
            color="text.secondary"
            fontSize={12}
          >
            {description}
          </Typography>
        </Stack>

        {fileRejections.length > 0 && (
          <Typography mt={2} color="error" variant="body2">
            {fileRejections[0].errors[0].message}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default ThumbnailUploadComponent;
